import { render, staticRenderFns } from "./XhCertificate.vue?vue&type=template&id=ef9dc5da"
import script from "./XhCertificate.vue?vue&type=script&lang=js"
export * from "./XhCertificate.vue?vue&type=script&lang=js"
import style0 from "./XhCertificate.vue?vue&type=style&index=0&id=ef9dc5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports